import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const ArrowRight: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 14.99 9.01',
  cssHelper = Styling.fullWidthStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      aria-label='Arrow Right Icon'
      role='img'
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path
        color={fill}
        fill={fill}
        d='M10.41.01L8.99 1.36l2.23 2.19H-.01v1.92h11.27L8.99 7.66l1.42 1.35 4.58-4.51z'
        transition='fill 0.1s ease-in-out'
      />
    </Elements.Svg>
  );
};

export default ArrowRight;
